import React, { InputHTMLAttributes } from "react";
import { Modal, Spinner } from "react-rainbow-components";
import styled from "styled-components";

import { uploadImageReturnUrl } from "../../functions/storage";
import { IProduct } from "../../interfaces/product";
import { updateProduct } from "../../services/product.service";
import { useError } from "../../store/ErrorModal";
import {
  ButtonContainer,
  ButtonCreateAdmin,
  IconPlus,
  ImageSelected,
  InputAdmin,
  InputLabel,
  InputTextArea,
  Title,
} from "../common/FormComponent";
export const Container = styled.form`
  display: flex;
  flex-direction: column;
`;

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
}

const InputLabelAdmin = (props: InputProps) => (
  <>
    <InputLabel>{props.label}</InputLabel>
    <InputAdmin style={{ width: "100%" }} {...props} />
  </>
);

interface IProps {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  fetchData: () => void;
  oldData: IProduct;
}
function ModalEditProduct({ isOpen, setIsOpen, fetchData, oldData }: IProps) {
  const [image, setImage] = React.useState<any>();
  const [data, setData] = React.useState<{ [key: string]: any }>(oldData || {});
  const [blobImage, setBlobImage] = React.useState<File>();
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const fileInput = React.useRef<any>();
  const { onError } = useError();

  const handleCloseModal = () => setIsOpen(false);

  const InputClick = () => fileInput.current.click();

  const handleChangeData = (key: string, value: string) => {
    const nData = data;
    nData[key] = value;
    return setData(nData);
  };
  const handleFile = (event: React.ChangeEvent<HTMLInputElement>) => {
    const fileUploaded = event.currentTarget.files;
    if (!fileUploaded) return;
    const imageAsFile = fileUploaded[0];
    setBlobImage(imageAsFile);
    let reader = new FileReader();
    reader.readAsDataURL(imageAsFile);
    reader.onload = () => {
      setImage(reader.result);
    };
  };

  const handleClickSubmit = async (event: React.SyntheticEvent) => {
    event.preventDefault();
    const reqData: { [key: string]: any } = data;

    if (!reqData.productName || !reqData.productDescription || !reqData.price)
      return onError("กรุณากรอกข้อมูลให้ครบทุกช่อง");

    reqData["type"] = oldData.type;
    if (reqData.dayRange) reqData["timeRange"] = reqData.dayRange * 1440;
    try {
      setIsLoading(true);
      if (blobImage) {
        const imageUrl = (await blobImage)
          ? await uploadImageReturnUrl(blobImage, "/product/")
          : undefined;
        reqData["imageUrl"] = imageUrl;
      }
      Object.keys(reqData).forEach(
        (key) => reqData[key] === undefined && delete reqData[key]
      );
      await updateProduct(oldData.productId, reqData);
      fetchData();
      handleCloseModal();
      setIsLoading(false);
    } catch (error: any) {
      setIsLoading(false);
      return onError(error as any);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleCloseModal}
      style={{ padding: "1rem" }}
    >
      <Container>
        {isLoading ? (
          <Spinner size="large" variant="brand" />
        ) : (
          <>
            <Title>แก้ไขสินค้าใหม่</Title>
            <div
              onClick={InputClick}
              style={{
                alignSelf: "center",
                margin: "1.5rem",
                cursor: "pointer",
              }}
            >
              <input
                type="file"
                ref={fileInput}
                accept="image/*"
                onChange={handleFile}
                style={{ display: "none", alignSelf: "center" }}
              />
              {image || oldData.imageUrl ? (
                <ImageSelected
                  src={image || oldData.imageUrl}
                  style={{
                    borderRadius: 0,
                    width: "auto",
                    height: "20rem",
                  }}
                  alt="profile"
                />
              ) : (
                <IconPlus />
              )}
            </div>
            <InputLabelAdmin
              label="ชื่อสินค้า"
              placeholder="เพิ่มชื่อสินค้า/โปรโมชั่น"
              defaultValue={data.productName}
              onChange={(e) => handleChangeData("productName", e.target.value)}
            />
            <InputLabel>คำอธิบาย</InputLabel>
            <InputTextArea
              placeholder="เพิ่มคำอธิบาย.."
              style={{ width: "100%" }}
              defaultValue={data.productDescription}
              onChange={(e) =>
                handleChangeData("productDescription", e.target.value)
              }
            />
            <InputLabelAdmin
              label="ราคา (บาท)"
              type="number"
              min="0"
              placeholder="ราคา (บาท)"
              defaultValue={data.price}
              onChange={(e) => handleChangeData("price", e.target.value)}
            />

            {oldData.type === "product" ? (
              <InputLabelAdmin
                label="จำนวนสินค้า (ชิ้น)"
                type="number"
                min="0"
                placeholder="จำนวนคงเหลือ"
                defaultValue={data.amount}
                onChange={(e) => handleChangeData("amount", e.target.value)}
              />
            ) : oldData.type === "chat" ? (
              <InputLabelAdmin
                label="ระยะเวลา (วัน)"
                type="number"
                min="0"
                placeholder="ระยะเวลา"
                defaultValue={data.dayRange}
                onChange={(e) => handleChangeData("dayRange", e.target.value)}
              />
            ) : (
              <InputLabelAdmin
                label="ระยะเวลา (นาที)"
                type="number"
                min="0"
                placeholder="ระยะเวลา"
                defaultValue={data.dayRange}
                onChange={(e) => handleChangeData("timeRange", e.target.value)}
              />
            )}
            <ButtonContainer style={{ marginTop: "1rem" }}>
              <ButtonCreateAdmin
                onClick={handleClickSubmit}
                value="แก้ไขสินค้า"
              />
            </ButtonContainer>
          </>
        )}
      </Container>
    </Modal>
  );
}

export default ModalEditProduct;
